<template>
  <div id="hres6ae">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres6aeIndex"
            searchBoxAlias="request"
            :maxRowspan="maxRowspan.index"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent"
            :unLoadBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :postHres6aeSave="postHres6aeSave"
            :columnsDetail="columns[app.nowLang].detail"
            :columnsDetailPopup="columns[app.nowLang].detailPopup"
            :indexSelected="indexSelected"
            :receivedHres6aeDetailSearch="receivedHres6aeDetailSearch"
            :maxRowspanDetail="maxRowspan.detail"
            :maxRowspanPopup="maxRowspan.detailPopup"
            :searchDetail="searchDetail"
            :searchIndex="searchIndex"
            :saveButtonDisp="saveButtonDisp" />
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6ae/mutation-types'
import detail from 'components/hres6ae/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres6ae',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      searchIndex: {
        dtereqst: '01' + moment().format('MM/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      },
      searchDetail: {
        dteworkst: moment().format('DD/MM/YYYY'),
        dteworken: moment().format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.receivedHres6aeColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6AE_INDEX_DISP,
      detailDisp: types.GET_HRES6AE_DETAIL_DISP,
      maxRowspan: types.GET_HRES6AE_MAX_ROWSPAN,
      columns: types.GET_HRES6AE_COLUMNS,
      labels: types.GET_HRES6AE_LABELS,
      index: types.GET_HRES6AE_INDEX,
      indexSelected: types.GET_HRES6AE_INDEX_SELECTED,
      currentNumseq: types.GET_HRES6AE_CURRENT_NUMSEQ,
      detail: types.GET_HRES6AE_DETAIL,
      detailSearch: types.GET_HRES6AE_DETAIL_SEARCH,
      saveButtonDisp: types.GET_HRES6AE_SAVE_BUTTON_DISP
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          this.searchDetail.dteworkst = this.searchIndex.dtereqst
          this.searchDetail.dteworken = this.searchIndex.dtereqen
          this.receivedHres6aeDetailSearch(this.searchDetail)
          this.toggle('detail')
          break
        case 'edit':
          if (this.indexSelected.numseq) {
            this.setSaveButtonDisp(true)
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              this.setSaveButtonDisp(false)
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.receivedHres6aeDetail(this.indexSelected)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          codempid: this.indexSelected.codempid,
          dtereq: this.indexSelected.dtereq,
          numseq: this.indexSelected.numseq,
          dtework: this.indexSelected.dtework,
          staappr: this.indexSelected.staappr
        }
        this.postHres6aeCancel({ cancelParams: sendParams, searchParams: this.searchIndex })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6AE_INDEX_SELECTED,
      setSaveButtonDisp: types.SET_HRES6AE_SAVE_BUTTON_DISP
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6AE_PAGE,
      receivedHres6aeColumnsLabels: types.RECEIVED_HRES6AE_COLUMNS_LABELS,
      receivedHres6aeIndex: types.RECEIVED_HRES6AE_INDEX,
      receivedHres6aeCurrentNumseq: types.RECEIVED_HRES6AE_CURRENT_NUMSEQ,
      receivedHres6aeDetail: types.RECEIVED_HRES6AE_DETAIL,
      receivedHres6aeDetailSearch: types.RECEIVED_HRES6AE_DETAIL_SEARCH,
      postHres6aeSave: types.POST_HRES6AE_SAVE,
      postHres6aeCancel: types.POST_HRES6AE_CANCEL
    })
  },
  components: {
    detail
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?2d4b2b1e